
<div class="quill-material-container" #container>
    <div class="editor" (click)="onTouched()" [ngStyle]="{'height': '200px'}"></div>
</div>

